<template>
  <div id="nprogress-container"></div>
</template>

<script>
  import nprogress from 'nprogress'
  import axios from 'axios'
  import { eventBus } from '@/utils'

  let pending = 0

  function handleError (error) {
    if (error.config && error.config.showProgress) {
      eventBus('progress-bar').$emit('done')
    }
    return Promise.reject(error)
  }
  axios.interceptors.request.use(function (config) {
    if (config.showProgress) {
      eventBus('progress-bar').$emit('start')
    }
    return config
  }, handleError)

  axios.interceptors.response.use(function (response) {
    if (response.config.showProgress) {
      eventBus('progress-bar').$emit('done')
    }
    return response
  }, handleError)

  export default {
    mounted () {
      nprogress.configure({
        parent: '#nprogress-container',
        showSpinner: false,
        trickleSpeed: 50,

        easing: 'ease',
        speed: 350
      })
      eventBus('progress-bar')
        .$on('start', this.start)
        .$on('done', this.done)
        .$on('set', (val) => { nprogress.set(val) })
        .$on('inc', (val) => { nprogress.inc(val) })
    },
    methods: {
      start () {
        pending++
        nprogress.start()
      },

      done () {
        pending--
        if (!pending) {
          nprogress.done()
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import 'nprogress/nprogress.css'

  $nprogress-bar-color = #49bdff
  $nprogress-peg-color = #0cda43
  #nprogress
    height: 5px
    .bar
      background: $nprogress-bar-color
      height: 4px

    .peg
      box-shadow: 0 0 10px $nprogress-peg-color, 0 0 5px $nprogress-peg-color

  #nprogress-container
    position: absolute
    left: 0
    right: 0
</style>



// WEBPACK FOOTER //
// frontend/src/components/core/AppProgressBar.vue